import type { LocationStatusFilter } from '@/shared/constants/location'
import { LOCATION_STATUS_FILTER } from '@/shared/constants/location'

export interface FilterableLocation {
  code: string
  nativeName: string
  name?: string
  isActive?: boolean
}

/**
 * Lowercases and strips Vietnamese diacritics so "Ha Noi" matches "Hà Nội".
 */
export function normalizeSearchText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036F]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase()
    .trim()
}

/**
 * Filters locations by keyword (code / native name / name, accent-insensitive) and active status.
 */
export function filterLocations<T extends FilterableLocation>(
  items: T[],
  keyword: string,
  status: LocationStatusFilter,
): T[] {
  const needle = normalizeSearchText(keyword)
  return items.filter((item) => {
    // * VI: Item thiếu isActive (API cũ) coi như đang hoạt động | EN: Missing isActive is treated as active
    const isActive = item.isActive ?? true
    if (status === LOCATION_STATUS_FILTER.ACTIVE && !isActive) return false
    if (status === LOCATION_STATUS_FILTER.INACTIVE && isActive) return false
    if (!needle) return true
    return [item.code, item.nativeName, item.name ?? ''].some((value) =>
      normalizeSearchText(value).includes(needle),
    )
  })
}
